import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface UploadStatusUpdateFileInterface {
  originalFileName?: string
  orderFile?: File[]
}
export const useUploadStatusUpdateFile = () => {
  const mutate = useMutation((data: UploadStatusUpdateFileInterface) => {
    console.log(data)
    const formData = new FormData()
    // Append all text-based fields
    formData.append('originalFileName', data.originalFileName || '000')
    // Append file if present
    if (data.orderFile && data.orderFile.length > 0) {
      data.orderFile.forEach((file) => {
        formData.append('orderFile', file)
      })
    }
    console.log('useUploadStatusUpdateFile: formdata', formData)
    return postAPI('/PartnerOrders/Manage/BulkStatusUpload', formData)
  })
  return mutate
}
export default useUploadStatusUpdateFile
